/**
 * useVersionCheck — deploy sonrası "eski sekme" sorununu çözer.
 *
 * SPA sekmesi açıkken yeni bir sürüm deploy edilirse kullanıcı yenileyene
 * kadar eski paketi görür. Bu hook 5 dakikada bir (ve pencere odaklanınca)
 * index.html'i no-store çekip bundle hash'ini karşılaştırır; değiştiyse
 * kalıcı bir "Yenile" toast'u gösterir.
 */
import { useEffect } from "react";
import { toast } from "sonner";

const getHash = (text) => (text.match(/main\.([a-z0-9]+)\.js/) || [])[1] || null;

export function useVersionCheck() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return undefined;
    const current = Array.from(document.scripts)
      .map((s) => getHash(s.src || ""))
      .find(Boolean);
    if (!current) return undefined;
    let notified = false;
    const check = async () => {
      if (notified || document.hidden) return;
      try {
        const res = await fetch("/", { cache: "no-store" });
        const latest = getHash(await res.text());
        if (latest && latest !== current) {
          notified = true;
          toast.info("Serpix'in yeni sürümü hazır 🚀", {
            description: "Son güncellemeleri görmek için sayfayı yenileyin.",
            duration: Infinity,
            action: { label: "Yenile", onClick: () => window.location.reload() },
          });
        }
      } catch {
        /* offline vb. — sessizce geç */
      }
    };
    const iv = setInterval(check, 5 * 60 * 1000);
    window.addEventListener("focus", check);
    return () => {
      clearInterval(iv);
      window.removeEventListener("focus", check);
    };
  }, []);
}
